import controller from './kform-tab-file-multiple.controller';
import template from './kform-tab-file-multiple.html';
import './kform-tab-file-multiple.scss';

export default {
	controller,
	template,
	bindings: {
		form:     '<?',
		kid:      '<',
		disabled: '<?ngDisabled',
		onLoad:   '&?',
	},
	require: {
		content: '^^?kformContent',
		files:   'ngModel',
		kform:   '^^?kform',
	},
};
